import { useUIStore } from '@/state/store';

export function PwaToast() {
  const visible = useUIStore((s) => s.pwaToastVisible);
  const hide = useUIStore((s) => s.hidePwaToast);

  if (!visible) return null;

  return (
    <div className="pwa-toast show">
      <div className="pt-icon">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="5" y="2" width="14" height="20" rx="2" />
          <line x1="12" y1="18" x2="12.01" y2="18" />
        </svg>
      </div>
      <div className="pt-text">
        <strong>Als App installieren</strong> für volle Erreichbarkeit
        <small>Auch wenn der Browser geschlossen ist · Service Worker + Web Push</small>
      </div>
      <div className="pt-actions">
        <button className="pt-btn" onClick={hide}>
          Installieren
        </button>
        <button className="pt-btn ghost" onClick={hide}>
          Später
        </button>
      </div>
    </div>
  );
}
